// import { stringify } from 'querystring';
import type { Reducer, Effect } from 'umi';
import { history } from 'umi';
import Service from '@/services/login';

import { setAuthority } from '@/utils/authority';
import { getPageQuery } from '@/utils/utils';

export type StateType = {
  status?: 'ok' | 'error';
  type?: string;
  currentAuthority?: 'user' | 'guest' | 'admin';
};

export type LoginModelType = {
  namespace: string;
  state: StateType;
  effects: {
    login: Effect;
    logout: Effect;
    loginWithServer: Effect;
    getCapture: Effect;
  };
  reducers: {
    changeLoginStatus: Reducer<StateType>;
  };
};

const Model: LoginModelType = {
  namespace: 'login',

  state: {
    status: undefined,
  },

  effects: {
    *login({ payload }, { call, put }) {
      const { userName: account, password, type, captchaKey, captchaCode } = payload;
      const roles = ['superadmin', 'agency', 'server', 'platformadmin'];

      try {
        const response: any = yield call(Service.login, {
          username: account,
          password,
          roles,
          captchaKey,
          captchaCode,
        });
        const { result } = response.data;
        if (result.code === 200) {
          localStorage.setItem('token', result.token);
          if (result.me.currentAuthority == 'server') {
            localStorage.setItem('server_token', result.token);
            localStorage.setItem('server_me', JSON.stringify(result.me));
            localStorage.setItem('isLoginToAgency', '0');
          }
          localStorage.setItem('me', JSON.stringify(result.me));
          yield put({
            type: 'changeLoginStatus',
            payload: {
              status: 'ok',
              type,
              currentAuthority: result.me.currentAuthority,
            },
          });
          const urlParams = new URL(window.location.href);
          const params = getPageQuery();
          let { redirect } = params as { redirect: string };
          if (redirect) {
            const redirectUrlParams = new URL(redirect);
            if (redirectUrlParams.origin === urlParams.origin) {
              redirect = redirect.substr(urlParams.origin.length);
              if (redirect.match(/^\/.*#/)) {
                redirect = redirect.substr(redirect.indexOf('#') + 1);
              }
            } else {
              window.location.href = '/';
              return;
            }
          }
          history.replace(redirect || '/');
        } else {
          yield put({
            type: 'changeLoginStatus',
            payload: {
              status: 'error',
              type,
            },
          });
        }
        return { code: 0, info: result };
      } catch (e) {
        // console.log('登录发生错误', e);
        yield put({
          type: 'changeLoginStatus',
          payload: {
            status: 'error',
            type: 'account',
          },
        });
        return { code: -1, info: e.message };
      }
    },

    logout() {
      const { redirect } = getPageQuery();
      // Note: There may be security issues, please note
      localStorage.clear();
      if (window.location.pathname !== '/user/login' && !redirect) {
        history.replace({
          pathname: '/user/login',
        });
      }
    },
    *loginWithServer({ payload }, { call, put }) {
      try {
        const response: any = yield call(Service.loginWithServer, {
          username: payload.username,
        });

        const {
          data: { loginWithServer: result },
        } = response;
        const { code, me, accessToken } = result;

        if (code === 200) {
          localStorage.setItem('token', accessToken);
          localStorage.setItem('me', JSON.stringify(me));
          localStorage.setItem('isLoginToAgency', '1');
          localStorage.setItem('antd-pro-authority', '["agency"]');
          window.location.href = '/';
          return 0;
        }
      } catch (error) {
        yield put({
          type: 'changeLoginStatus',
          payload: {
            isLoginToAgency: 0,
            status: 'error',
            currentAuthority: 'guest',
          },
        });
        localStorage.setItem('isLoginToAgency', '0');
        return error;
      }
    },
    *getCapture({ payload }, { call, put }) {
      try {
        const response: any = yield call(Service.getCapture, {
          ...payload,
        });
        const { result } = response.data;
        return result;
      } catch (e) {
        return e;
      }
    },
  },

  reducers: {
    changeLoginStatus(state, { payload }) {
      setAuthority(payload.currentAuthority);
      return {
        ...state,
        status: payload.status,
        type: payload.type,
      };
    },
  },
};

export default Model;
